import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from "@emotion/styled";
import { createFocusRingStyles } from "../../../util/createFocusRingStyles";
import { withFocusToggleClassName } from "../../../util/withFocusClassName";
export var BannerLinkStyled = withFocusToggleClassName(styled("a")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-weight: 500;\n    cursor: pointer;\n\n    // Elide if the link is too wide. We just need a non-inline type here.\n    display: inline-grid;\n    // IE11 hack\n    display: -ms-inline-flexbox;\n    vertical-align: bottom;\n\n    &,\n    &:visited {\n        color: currentColor;\n    }\n\n    text-decoration: underline;\n\n    // Only remove the underline if we're actually going to show a focus ring.\n    ", "\n\n    ", ";\n"])), function (_ref) {
  var focusMode = _ref.focusMode;
  return focusMode === "keyboard" ? "\n                &:focus {\n                    text-decoration: none;\n                }\n            " : "";
}, function (_ref2) {
  var themeMode = _ref2.themeMode;
  return createFocusRingStyles({
    theme: themeMode,
    componentRadius: "4px",
    gap: 1,
    componentBorderWidth: 1,
    innerColorOverride: "transparent"
  });
}));
BannerLinkStyled.displayName = "BannerLinkStyled";
//# sourceMappingURL=BannerLinkStyled.js.map